/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

/**
 * The custom type 'display_location' is a named-type used for representing a display location
 */
export enum DisplayLocation {
  Indoor = "Indoor",
  Outdoor = "Outdoor",
}

/**
 * The custom type 'display_power' is a named-type used for representing is display enabled or not
 */
export enum DisplayPower {
  OFF = "OFF",
  ON = "ON",
}

/**
 * The custom type 'user_role' is a named-type for presenting a role of a user in the system
 */
export enum UserRole {
  admin = "admin",
  regular = "regular",
  reviewer = "reviewer",
}

//==============================================================
// END Enums and Input Objects
//==============================================================
